import { ChevronDown24Filled, ChevronRight24Filled } from "@fluentui/react-icons";
import { useState } from "react";

interface CollapseTopProps {
    title: string;
    rightButtonTitle?: string;
    expand: () => void;
    rightButton?: () => void;
    startsExpanded?: boolean;
    rightValueUnderline?: boolean
    extraElement?: JSX.Element;
}

export function CollapseTop({
    title,
    rightButtonTitle = "",
    expand,
    rightButton,
    startsExpanded = false,
    rightValueUnderline = false,
    extraElement,
}: CollapseTopProps) {
    const underline = rightValueUnderline ? "underline" : "";
    const [oeeExpanded, setOeeExpanded] = useState(startsExpanded);

    return (
        <div
            className="flex items-center justify-between p-4 bg-collapse-header-light dark:bg-collapse-header-dark text-primary-dark dark:text-primary-light"
            onClick={() => {
                expand();
                setOeeExpanded(!oeeExpanded);
            }}
        >
            <div className="flex items-center space-x-2">
                <div className="text-gray-500">
                    {oeeExpanded ? <ChevronDown24Filled /> : <ChevronRight24Filled />}
                </div>
                <span className="ps-2 font-bold text-base">{title}</span>
                {extraElement}
            </div>
            {rightButtonTitle && (
                <button
                    className={`ps-2 font-bold text-left text-base ${underline} cursor-pointer`}
                    onClick={(e) => {
                        e.stopPropagation();
                        rightButton && rightButton();
                    }}
                >
                    {rightButtonTitle}
                </button>
            )}
        </div>
    );
}
